import { startSubmit, stopSubmit } from 'redux-form';
import _ from 'lodash';
import { fetchAction } from 'barnyard/utils/';
import { updateGlobalCSRFToken } from '~/accounts/core/utils';
import * as types from '../constants';

export const profileCreate = values => dispatch => fetchAction(
  dispatch,
  types.MERCHANT_PROFILE_CREATE,
  {},
  {
    url: '/api/accounts/merchants/signup/',
    body: values,
    method: 'POST',
    postBefore: () => {
      dispatch(startSubmit(types.SIGNUP_FORM));
    },
    postSuccess: () => {
      dispatch(stopSubmit(types.SIGNUP_FORM));

      updateGlobalCSRFToken();
    },
    postFailure: (error) => {
      dispatch(stopSubmit(types.SIGNUP_FORM, {
        _error: {
          title: error.detail || 'Error Creating Account',
          details: `
Please correct the form and try again.
If this issue continues, contact us via the chat icon in the bottom right.`
        },
        ...error
      }));
    }
  }
);

export const profileFetch = () => dispatch => fetchAction(
  dispatch,
  types.MERCHANT_PROFILE_FETCH,
  {},
  {
    url: '/api/accounts/profile/',
    redirectToSignin: false,
    success: (json) => {
      dispatch({
        type: types.MERCHANT_PROFILE_FETCH.success,
        result: _.omit(json, 'buyer'),
        buyer: json.buyer
      });
    }
  }
);
